export enum IdCardType {
    GUEST = "GUEST",
    PAYROLL = "PAYROLL",
    REFILL = "REFILL",
    SUBSCRIPTION = "SUBSCRIPTION",
}

export enum IdCardStatus {
    ASSIGNED = "ASSIGNED",
    UNASSIGNED = "UNASSIGNED",
    EXPIRED = "EXPIRED",
    INACTIVE = "INACTIVE",
}

export enum IdCardHolderKind {
    USER = "USER",
    COMPANY = "COMPANY",
}

export type IdCardHolder =
    | Readonly<{ kind: IdCardHolderKind.USER; name: string; employeeId: string }>
    | Readonly<{ kind: IdCardHolderKind.COMPANY; name: string }>

export type IdCardCompany = Readonly<{
    id: string
    name: string
}>

export type IdCardListItem = Readonly<{
    id: number
    cardNumber: string
    cardType: IdCardType
    batch?: string
    created: string
    isBlocked: boolean
    holder?: IdCardHolder
    company?: IdCardCompany
    assignedOn?: string
    validFrom?: string
    validTo?: string
    scansToday: number
    scansPerDay?: number
}>

export type IdCardRow = IdCardListItem & Readonly<{ status: IdCardStatus }>

export enum IdCardStatusFilterOption {
    ALL = "ALL",
    GUEST = "GUEST",
}

export type IdCardStatusFilter = IdCardStatus | IdCardStatusFilterOption

export type IdCardsListFilters = Readonly<{
    status: IdCardStatusFilter
    companyId?: string
    cardholder?: string
    cardType?: IdCardType
}>

export type IdCardStatusOption = Readonly<{
    value: IdCardStatusFilter
    count: number
}>

export type IdCardCompanyOption = IdCardCompany & Readonly<{ count: number }>

export type IdCardCardholderOption = Readonly<{
    value: string
    name: string
    companyName?: string
    count: number
}>

export type IdCardsListView = Readonly<{
    rows: IdCardRow[]
    total: number
    assignedCount: number
    unassignedCount: number
    isFiltering: boolean
    statusOptions: ReadonlyArray<IdCardStatusOption>
    companyOptions: ReadonlyArray<IdCardCompanyOption>
    cardholderOptions: ReadonlyArray<IdCardCardholderOption>
    selectedCompany: IdCardCompanyOption | null
    selectedCardholder: IdCardCardholderOption | null
}>
